export const textStyles = "t1pxoxb5";
export const cardsContainer = "c1ws52pe";
export const card = "c1ke4x0n";
export const content = "c1clslmm";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");